import React, { useState } from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    Card,
    Collapse,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Tooltip,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    AutocompleteField,
    InputSearch,
    ManageCsvDropdown,
} from 'common/components';

import { getExecutivesOptions } from '../helpers';

const Filters = ({
    downloadFile,
    executives,
    filterData,
    financierProducts,
    handleOnChangeFilter,
    handleOnChangeSearch,
    isFetchingExecutives,
    statusList,
}) => {
    const { t } = useTranslation();
    const [filterIsOpen, setFilterIsOpen] = useState(false);
    const toggleFilter = () => setFilterIsOpen((prev) => !prev);

    return (
        <Card>
            <Card.Body>
                <Box sx={{ alignItems: 'center', display: 'flex', gap: 0 }}>
                    <InputSearch
                        onChange={handleOnChangeSearch}
                        placeholder={t('Search')}
                        value={filterData?.searchText}
                    />
                    <Tooltip title={t('Filter', { count: 2 })}>
                        <IconButton onClick={toggleFilter} size="large">
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>
                    <ManageCsvDropdown
                        handleDownload={() => downloadFile(filterData)}
                    />
                </Box>
                <Collapse in={filterIsOpen}>
                    <Grid container sx={{ mt: 1 }} justifyContent="flex-end">
                        <Grid size={{ md: 6, xs: 18 }}>
                            <AutocompleteField
                                disabled={isFetchingExecutives}
                                label={
                                    isEmpty(filterData?.executiveName)
                                        ? t('All executives')
                                        : t('Executive')
                                }
                                onChange={(value) =>
                                    handleOnChangeFilter(value, 'executiveName')
                                }
                                options={getExecutivesOptions(executives)}
                                value={filterData?.executiveName}
                            />
                        </Grid>

                        <Grid size={{ md: 6, xs: 18 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>
                                    {t('Financial product')}
                                </InputLabel>
                                <Select
                                    label={t('Financial product')}
                                    onChange={(e) =>
                                        handleOnChangeFilter(
                                            e.target.value,
                                            'product',
                                        )
                                    }
                                    value={filterData?.product || 'all'}
                                    variant="outlined"
                                >
                                    <MenuItem
                                        key="financier-product-all"
                                        value="all"
                                    >
                                        {t('All text', {
                                            context: 'male',
                                            count: 2,
                                        })}
                                    </MenuItem>
                                    {financierProducts.map(({ id, name }) => (
                                        <MenuItem
                                            key={`financier-product-${id}-${name}`}
                                            value={id}
                                        >
                                            {name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid size={{ md: 6, xs: 18 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>{t('Status')}</InputLabel>
                                <Select
                                    label={t('Status')}
                                    onChange={(e) =>
                                        handleOnChangeFilter(
                                            e.target.value,
                                            'status',
                                        )
                                    }
                                    value={filterData?.status || 'all'}
                                    variant="outlined"
                                >
                                    {statusList.map(
                                        ({
                                            label,
                                            value,
                                            disabled = false,
                                        }) => (
                                            <MenuItem
                                                disabled={disabled}
                                                key={`agent-select-${value}-${label}`}
                                                value={value}
                                            >
                                                {label}
                                            </MenuItem>
                                        ),
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Collapse>
            </Card.Body>
        </Card>
    );
};

Filters.propTypes = {
    downloadFile: PropTypes.func,
    executives: PropTypes.array,
    filterData: PropTypes.object,
    financierProducts: PropTypes.array,
    handleOnChangeFilter: PropTypes.func,
    handleOnChangeSearch: PropTypes.func,
    isFetchingExecutives: PropTypes.bool,
    statusList: PropTypes.array,
};

export default Filters;
